const generateWorkCode = (detailUrl: string) => {
  const matchedWorkCode = /.*job\/(.*).*?\/sid/.exec(detailUrl);
  return matchedWorkCode ? matchedWorkCode[1] : "";
};

const generateClientShopId = (docId: string) => {
  const matchedClientShopId = /.*_(.*)$/.exec(docId);
  return matchedClientShopId ? matchedClientShopId[1] : "null";
};

export const generateGaLabel = (detailUrl: string, docId: string) => {
  const matchedWorkCode = generateWorkCode(detailUrl);
  const matchedClientShopId = generateClientShopId(docId);
  return `${matchedWorkCode}_${matchedClientShopId}`;
};
